import { keyframes } from "@emotion/react";

export const shimmerGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const ellipsisAnimation = keyframes`
  0% {
    width: 0ch;
  }
  25% {
    width: 1ch;
  }
  50% {
    width: 2ch;
  }
  75% {
    width: 3ch;
  }
  100% {
    width: 0ch;
  }
`;
